import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import { GraphQLFetchWithAbort, SearchDataSource } from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      { newName: GraphQLFetchWithAbort.NAME, oldNameMatcher: /^graphql_fetch_with_abort/m },
      { newName: SearchDataSource.NAME, oldNameMatcher: /^search_listing_data_source/m },
    ],
  });
};
